"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const button_1 = __importDefault(require("@kyruus/button"));
const SmartDrawer_styles_1 = require("./SmartDrawer.styles");
/* eslint-disable no-console */
const SmartDrawer = ({ children, anchors: { mobile: mobileAnchor = 'bottom', desktop: desktopAnchor = 'bottom' } = {}, variants: { mobile: mobileVariant = 'temporary', desktop: desktopVariant = 'persistent' } = {}, open: { mobile: mobileOpen = false, desktop: desktopOpen = false } = {}, disabledMobileButton = false, onOpenMobile, onCloseMobile, labels: { showMobileDrawerButtonLabel = '' } = {} }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SmartDrawer_styles_1.MobileDrawer, { anchor: mobileAnchor, variant: mobileVariant, open: mobileOpen, onClose: onCloseMobile, ModalProps: {
                keepMounted: true
            } }, children),
        react_1.default.createElement(SmartDrawer_styles_1.MobileDrawerOpener, null,
            react_1.default.createElement(button_1.default, { disabled: disabledMobileButton, mode: "floating-primary", onClick: onOpenMobile }, showMobileDrawerButtonLabel)),
        react_1.default.createElement(SmartDrawer_styles_1.DesktopDrawer, { anchor: desktopAnchor, variant: desktopVariant, open: desktopOpen }, children)));
};
SmartDrawer.displayName = 'SmartDrawer';
exports.default = SmartDrawer;
//# sourceMappingURL=SmartDrawer.js.map